import {Pipe, PipeTransform} from '@angular/core';
import {ActionService} from "../services/authorization-management/action/action.service";
import {AuthService} from "../services/auth/auth.service";

@Pipe({
  name: 'hasPermission',
  pure: false
})
export class HasPermissionPipe implements PipeTransform {
  private readonly permissionCache = new Map<string, boolean>();

  constructor(private readonly actionService: ActionService, private readonly authService: AuthService) {
  }

  transform(permission: string, action: string): boolean {


    const cacheKey = `${permission}_${action}`;

    if (this.permissionCache.has(cacheKey)) {
      return this.permissionCache.get(cacheKey)!;
    }


    if (this.authService.isSuperAdmin()) {
      return true;
    }
    this.actionService.actionCheck(permission, action).then((response: any) => {
      this.permissionCache.set(cacheKey, response);
    });

    return false;
  }
}
